const AVATAR_COLORS = ["#3D7A76", "#304153", "#4F8F8B", "#6B8248", "#C48A2A", "#2D5F5C"];

export function displayName(username?: string, email?: string, fallback = "—"): string {
  const raw = (username || "").trim() || (email || "").trim();
  if (!raw) return fallback;
  if (raw.includes("@") && !username) return raw.split("@")[0] || fallback;
  return raw;
}

export function initials(name: string): string {
  const parts = name.replace(/[@._-]+/g, " ").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function avatarColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) hash = (hash * 31 + name.charCodeAt(i)) | 0;
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

function asDate(value?: string | number[]): Date | null {
  if (value == null || value === "") return null;
  if (Array.isArray(value) && value.length >= 3) {
    const [y, m, d, h = 0, min = 0, s = 0] = value;
    const parsed = new Date(y, m - 1, d, h, min, s);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }
  const parsed = new Date(String(value));
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function dateLocale(lang: string): string {
  return (lang || "tr").startsWith("en") ? "en-GB" : "tr-TR";
}

export function formatDateTime(value: string | number[] | undefined, lang: string): string {
  const d = asDate(value);
  if (!d) return "—";
  return new Intl.DateTimeFormat(dateLocale(lang), {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(d);
}

export function formatDate(value: string | number[] | undefined, lang: string): string {
  const d = asDate(value);
  if (!d) return "—";
  return new Intl.DateTimeFormat(dateLocale(lang), {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(d);
}

export function formatTime(value: string | number[] | undefined, lang: string): string {
  const d = asDate(value);
  if (!d) return "";
  return new Intl.DateTimeFormat(dateLocale(lang), {
    hour: "2-digit",
    minute: "2-digit",
  }).format(d);
}
